import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

import { getJson } from '@hcr/api/shared'

import type { AccommodationDto, ProblemDetailsDto } from '../../dtos'
import { AccommodationDtoSchema } from '../../dtos'
import type { AuthorizedRequestParams } from '../../models'
import { createAuthorizationHeader } from '../../utils'

interface AccommodationDetailsQueryParams {
  accommodationId: number
}

export const createAccommodationsDetailsQueryKey = (params: AccommodationDetailsQueryParams) => [
  'consumer',
  'accommodations',
  params,
]

export const createAccommodationDetailsQuery =
  (baseUrl: string) =>
  <Data = AccommodationDto>(
    { idToken, ...params }: AuthorizedRequestParams & AccommodationDetailsQueryParams,
    options?: Partial<UseQueryOptions<AccommodationDto, ProblemDetailsDto, Data>>
  ) =>
    useQuery<AccommodationDto, ProblemDetailsDto, Data>({
      ...options,
      queryKey: createAccommodationsDetailsQueryKey(params),
      queryFn: () =>
        getJson({
          headers: createAuthorizationHeader(idToken),
          schema: AccommodationDtoSchema,
          url: `${baseUrl}/accommodations/${params.accommodationId}/details`,
        }),
    })
